<template>
  <div class="flex justify-between items-center mb-0 md:mb-[24px] px-[24px] py-[19px] border-b border-gray-200">
    <!-- Search input with search & clear icons -->
    <div class="relative w-1/2">
      <!-- Search icon (left) -->
      <IconButton icon="ri-search-line" ariaLabel="Search products" size="sm"
        class="!absolute left-3 top-1/2 -translate-y-1/2 !text-[#000000]"
        @click="searchProducts" />

      <!-- Input -->
      <input
        type="text"
        :placeholder="$t('orderCatalog.searchPlaceHolder')"
        v-model="globalCatalogStore.productSearchTerm"
        @keydown.enter="searchProducts"
        class="w-full border border-gray-300 rounded-md pl-10 pr-10 py-2 focus:outline-none"
      />

      <!-- Clear icon (right) -->
      <IconButton
        v-if="globalCatalogStore.productSearchTerm"
        icon="ri-close-line" ariaLabel="Clear search" size="sm"
        class="!absolute right-3 top-1/2 -translate-y-1/2 !text-gray-500 hover:!text-black"
        @click="clearSearch" />
    </div>

    <!-- Close modal button -->
    <IconButton
      id="order-catalog-header-close-modal"
      icon="ri-close-line"
      ariaLabel="Close catalog"
      class="!text-[#4B5563] hover:!text-[#111827] text-2xl leading-none"
      @click="emit('close-modal')" />
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { getLanguage } from '@/utilities/cookies';
import { useGlobalCatalogStore } from '@/stores/globalCatalogStore'
import IconButton from '@/components/atoms/buttons/IconButton.vue';

const { t, locale } = useI18n()
locale.value = getLanguage();

const globalCatalogStore = useGlobalCatalogStore()

const searchProducts = () => {
  if (globalCatalogStore.productSearchTerm.length >= 3) {
    localStorage.setItem('productSearchTerm', globalCatalogStore.productSearchTerm);
    globalCatalogStore.loadProducts();
  }
}

const clearSearch = () => {
  globalCatalogStore.clearProductSearch();
}

const emit = defineEmits(['close-modal'])
</script>
